<template>
  <div
    ref="recast"
    class="simplecast-recast"
  >
    <Video :store="store" />
  </div>
</template>

<script>
import Store from '../store'
import Video from './Video'

export default {
  components: {
    Video
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    websocket: {
      type: String,
      default: ''
    }
  },
  data () {
    return { store: new Store() }
  },
  created () {
    this.store.getRecast(this.id)
  }
}
</script>

<style lang="scss">

</style>
